export const DCO_CAMPAIGN_CREATIVE_REPORT_ID = 'dco-campaign-creative';
